import React from 'react';
import Avatar from 'react-avatar';
import moment from 'moment';
import {
 Image,
 Button,
} from 'react-bootstrap';
import { Link } from 'react-router';
import TourDates from './TourDates';
import unpin from '../../../../public/unpin.png';
import pin from '../../../../public/pin.png';

class BookingRequestBadge extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      //
    }
  }
  //Function to generate HTML of pin icon section for booking
  renderPinUnpin(isPin, id){
    if(isPin === true){
      return(
      <img className="pin-unpin-image" src={pin} alt="Pin" onClick={() => this.props.handleTogglePinUnpinIcon(isPin, id)}/>
      );
    }else{
      return(
      <img className="pin-unpin-image" src={unpin} alt="UnPin" onClick={() => this.props.handleTogglePinUnpinIcon(isPin, id)}/>
      );
    }
  }
  renderArchive(state,request){
    if(state=="Archived"){
      return(
      <Button bsStyle="success" bsSize="small" onClick={() => this.props.handleArchive(request,"AR")} disabled>
        <i className="fa fa-trash" /> Archive
      </Button>
      )
    } else{
      return(
      <Button bsStyle="success" bsSize="small" onClick={() => this.props.handleArchive(request,"AR")}>
        <i className="fa fa-trash" /> Archive
      </Button>
      )
    }
    
  }

  render() {
    let image = <Avatar name={this.props.request.tour.name} color="#326a34" size={250} />;
    if (this.props.request.tour.image) {
      image = <Image src={this.props.request.tour.image} responsive />;
    }
    let tourToday = <br/>;
    let dateSectionClass = 'tour-today text-center date-text-class';
    if (moment().isBetween(this.props.request.tour.start, this.props.request.tour.end)) {
      // TODO: Find out which day of the tour
      tourToday = 'Ongoing';
      dateSectionClass = 'tour-today text-center';
    } else if (moment().isBefore(this.props.request.tour.start)) {
      tourToday = `Begins ${moment(this.props.request.tour.start).fromNow()}`;
      dateSectionClass = 'tour-today text-center';
    }

    let brandName = this.props.request.brand ? this.props.request.brand.name : <br/>;

    return (
      <div className="col-sm-6 col-md-6 tour-container">
        <div className="tour">
          <div className="Archive-style">
            {this.renderArchive(this.props.request.tour.state,this.props.request.tour)}
          </div>
          <div className="pin-unpin-icon">
            {this.renderPinUnpin(this.props.request.is_pin,this.props.request.id)}
            </div>
          <Link to={`/booking/${this.props.request.id}`}>
            <div className="edit-overlay-container">
              <div className="background-test">
              </div>       
              <div className="edit-overlay">
                <h3>Details</h3>
              </div>
            </div>
            <div className="tour-image">
              {image}
            </div>
            <div className="tour-name">
              <strong>{ this.props.request.tour.name }</strong><br />
              { this.props.request.tour.tag_line }<br />
            { brandName }
            </div>
          </Link>
          <div className="tour-dates">
            <TourDates
              start={this.props.request.tour.start}
              end={this.props.request.tour.end}
            />
          </div>

          <div className={dateSectionClass}>
            {tourToday}
          </div>
        </div>
      </div>
    );
  }
}
export default BookingRequestBadge;



// WEBPACK FOOTER //
// src/routes/booking/components/BookingRequestBadge.js